export { default as Large } from '@/assets/graphics/splashes/large.svg';
export { default as Medium } from '@/assets/graphics/splashes/medium.svg';
export { default as Small } from '@/assets/graphics/splashes/small.svg';

export type Theme = 'primary';
